<template>
    <div>
        <b-card body-class="pt-0 p-3">
            <template v-slot:header>
                <b-row>
                    <b-col><span class="h4">Permissions</span></b-col>
                    <b-col class="text-right">
                        <b-button @click="$bvModal.show('addUserModal')" size="sm"><i class="fa-regular fa-plus"></i> Add User</b-button>
                    </b-col>
                </b-row>
            </template>


            <!--=========Table =========-->
            <div class="bg-light p-3">
                <b-row>
                    <b-col>
                        <b-input-group>
                            <template #prepend>
                                <b-input-group-text>
                                    <i class="fa-solid fa-search"></i>
                                </b-input-group-text>
                            </template>
                            <b-form-input v-model="filterSearch" placeholder="Search First Name, Last Name, or Email"></b-form-input>

                        </b-input-group>


                    </b-col>
                    <b-col cols="4">
                        <div class="d-flex">
                            <b-button @click="goToPrevPage()">Prev</b-button>
                            <div style="max-width: 100px">
                                <b-card v-if="!table.editCurrentPage"
                                        @click="table.editCurrentPage = !table.editCurrentPage"
                                        class="mb-0 h-100"
                                        style="min-width: 100px"
                                        body-class="py-1 px-3 text-center">
                                    {{ table.currentPage }} - {{ tablePageLength }}
                                </b-card>
                                <b-form-input v-else
                                              class="text-center"
                                              type="number"
                                              v-model="table.currentPage"
                                              @change="enterCustomPage">
                                </b-form-input>
                            </div>

                            <b-button @click="goToNextPage()">Next</b-button>
                        </div>
                    </b-col>

                    <b-col cols="2">
                        <div class="d-flex align-items-center">
                            <span class="mr-2">Limit: </span>
                            <b-form-select @change="table.currentPage = 1" class="w-50" :options="[10, 25, 50, 75, 100]" v-model="table.perPage"></b-form-select>
                        </div>

                    </b-col>
                </b-row>
            </div>
            <b-table class="text-center"
                     head-variant="dark"
                     hover
                     striped
                     bordered
                     selectable
                     show-empty
                     ref="resultsTable"
                     @row-selected="onRowSelected"
                     selected-variant="success"
                     :busy="table.isBusy"
                     :per-page="table.perPage"
                     :current-page="table.currentPage"
                     :items="filteredOrders"
                     :fields="table.fields">
                <template v-slot:cell(name)="data">
                    {{ data.value }}
                </template>

                <template v-slot:cell(user_id)="data">
                    {{ data.item.id }}
                </template>
                <template v-slot:cell(created)="data">
                    {{ data.item.created_at | date }}
                </template>

                <template v-slot:cell(roles)="data">
                    <template v-for="(role, index) in data.item.roles">
                        {{role.name | titleCase }}<span v-if="index != (data.item.roles.length - 1)">, </span>
                    </template>
                </template>

                <template v-slot:table-busy>
                    <LoadingSpinner :busy="table.isBusy"/>
                </template>

            </b-table>
            <!--=========End Table =========-->





        </b-card>
        <router-link to="permissions">
            <b-button class="float-right mb-5" variant="primary" size="lg">Permissions Table</b-button>
        </router-link>






        <!--*****************-->
        <!--***** MODALS *****-->
        <!--*****************-->

        <!--save filter-->
        <b-modal id="saveFilterModal"
                 ref="saveFilterModal"
                 ok-title="Save Filter"
                 title="Save Filter">
            <h5 class="my-4 text-center">Please enter a name to associate to this result view:</h5>
            <b-input ref="customFilterInput" class="mb-2 text-center" type="text" v-model="savedFilterName"></b-input>
            <div class="text-center">
                <b-button :disabled="!savedFilterName" size="lg" variant="primary" @click="saveCustomFilters">
                    Save Filter
                </b-button>
            </div>

            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>


        <!--Delete Saved Filter-->
        <b-modal id="deleteFilterModal"
                 ref="deleteFilterModal"
                 ok-title="Delete Saved Filter"
                 title="Delete Saved Filter">
            <b-container fuild>
                <b-form-row>
                    <b-col>
                        <h5 class="my-4 text-center">Are you sure you want to delete the saved filter<br><mark>  {{ savedFilterToDelete }}  </mark></h5>
                        <div class="text-center">
                            <b-button size="lg" variant="danger" @click="deleteCustomFilter(savedFilterToDelete)">
                                Delete Filter
                            </b-button>
                        </div>
                    </b-col>
                </b-form-row>
            </b-container>

            <template #modal-footer="{ cancel }">
                <b-button size="sm" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>



        <!--add new User-->
        <b-modal ref="addUserModal"
                 id="addUserModal"
                 title="Create New User">
            <b-container fuild>
                <b-row class="mb-3">
                    <b-col>
                        <label>First Name:</label>
                        <b-input v-model="newUser.firstName"></b-input>
                    </b-col>
                    <b-col>
                        <label>Last Name:</label>
                        <b-input v-model="newUser.lastName"></b-input>
                    </b-col>
                </b-row>

                <b-row class="mb-3">
                    <b-col>
                        <label>Email:</label>
                        <b-input v-model="newUser.email"></b-input>
                    </b-col>
                    <b-col>
                        <label>Password:</label>
                        <b-input v-model="newUser.password"></b-input>
                    </b-col>
                </b-row>

            </b-container>
            <template #modal-footer="{}">
                <b-button @click="$bvModal.hide('addUserModal')">Cancel</b-button>
                <b-button :variant="newUser.saved ? 'success' : 'primary' " @click="createUser()" :disabled="newUser.isSaving || newUser.saved">
                    <span v-if="newUser.saved">Saved <i class="ml-1 fa-regular fa-check"></i></span>
                    <span v-else>Create User <i :class="newUser.isSaving ? 'ml-1 fa-regular fa-spinner fa-spin' : 'ml-1 fa-regular fa-plus' "></i></span>
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import _ from 'lodash';

    export default {
        name: 'settings-user-list',
        components: {
            LoadingSpinner,
        },
        data() {
            return {
                filterSearch: null,
                users: [],
                roles: null,
                rolesByUser: null,
                baseFilters: [
                    {filterName: 'First Name', filterValue: null,filterParameter: 'contains'},
                ],
                filterSelected: null,
                filterList:  [
//                    { value:{name: 'Order ID', field:'id'}, text: 'Order ID' },
                    { value:{name: 'First Name', field:'first_name'}, text: 'First Name' },
//                    { value:{name: 'Last Name', field:'last_name'}, text: 'Last Name' },
                ],

                filteredUsers: null,
                masterQuery: [],
                savedFilterName: null,
                savedFilters: {},
                savedFilterToDelete: null,
                loadSavedFilter: false,

                newUser: {
                    saved: false,
                    isSaving:false,
                    firstName: null,
                    lastName: null,
                    email: null,
                    password: null,
                    group: null,
                    accessLevel: null,
                    canOverRideAppraisal: null,
                    canReceiveNotifications: null,
                    staffMember: null,
                    activeUser: null,
                },


                table: {
                    refresh: false,
                    allRowsSelected: false,
                    selected: [],
                    isBusy: false,
                    editCurrentPage: false,
                    customPage: this.currentPage,
                    perPage: 25,
                    currentPage: 1,
                    fields: ['user_id',{ key: 'name', sortable: true },'email', { key: 'roles', sortable: true }],
                },
            };
        },
        created() {
            this.getUsers();
            this.getRoles();

//            this.getFilteredUsers();
            this.masterQuery.push(this.baseFilters[0])
        },
        updated() {
            this.$nextTick(function () {
                var filtersWrapper = document.querySelector('.active-filters-height');
                if(filtersWrapper) {
                    filtersWrapper.scrollTop = filtersWrapper.scrollHeight;
                }
            })
        },
        watch: {
            filterSelected: function () {
                let filter = {
                    filterName: this.filterSelected.name,
                    filterField: this.filterSelected.field,
                    filterParameter: this.parameters(this.filterSelected),
                    filterValue: null,
                };
                this.masterQuery.push(filter);
            },
            currentPage: function () {
                this.currentPage = parseFloat(this.currentPage)
            },
            perPage() {
                this.currentPage = 1;
            },
            masterQuery: {
                deep: true,
                handler() {
                }
            }
        },

        computed: {
            fullName() {
                return `${this.newUser.firstName} ${this.newUser.lastName}`;
            },
            tablePageLength() {
                if( (this.users.length / this.table.perPage) < 1) {
                    return 1
                } else {
                    return Math.ceil(this.users.length / this.table.perPage);
                }
            },
            filteredOrders() {
                let filterValue = this.filterSearch;
                if (filterValue != null) {
                    filterValue = filterValue.toLowerCase();
                    return this.users.filter(user => user.name.toLowerCase().includes(filterValue) || user.email.toLowerCase().includes(filterValue) );
                } else {
                    return this.users.filter(user => user);
                }

            },
        },
        methods: {
            getUsers() {
                this.table.isBusy = true;
                this.$http.get('/users').then(response => {
                    this.users = response.data.data;
                    this.table.isBusy = false;
                    this.$nextTick(() => {
                    });
                });
            },
            getRoles() {
                this.$http.get('/roles').then(response => {
                    this.roles = response.data.data
                    this.createRollsByUser();
                });
            },

            createRollsByUser() {
                this.users.forEach( user => {
                    user.roles = this.roles.filter(role => role.users.data.some(roleUser => roleUser.id == user.id) )
                    this.table.isBusy = false;
                });
            },

            createUser() {
                this.newUser.isSaving = true;
                let payload = {
                    id: null,
                    name: this.fullName,
                    email: this.newUser.email,
                    password: this.newUser.password,
                    deleted_at: null,
                    created_at: null,
                    updated_at: null
                };
                this.$http.post('/users', payload).then(response => {
                        this.users.push(response.data.data)
                        this.newUser.firstName = null,
                        this.newUser.lastName = null,
                        this.newUser.email = null,
                        this.newUser.password = null,
                        this.$bvModal.hide('addUserModal');
                        this.newUser.isSaving = false;
                        }).catch((e)=>{
                            this.newUser.isSaving = false;
                            console.log('not saved: ', e)
                        });
            },


            removeFilter(index) {
                this.masterQuery.splice(index, 1);
            },
            updateFilter(index,filter) {
                this.masterQuery[index] = filter;
            },
            clearFilters() {
                this.masterQuery = [];
            },

            //  Saved Filters
            saveCustomFilters() {
                this.savedFilters[this.savedFilterName] = JSON.parse(JSON.stringify(this.masterQuery));
//                this.savedFilters[this.savedFilterName] = Object.assign({}, this.masterQuery);
                this.$refs["saveFilterModal"].hide();
                this.savedFilterName = null;
            },
            deleteCustomFilter(filterToDelete) {
                delete this.savedFilters[filterToDelete];
                this.$refs["deleteFilterModal"].hide();
                this.$forceUpdate();
            },
            loadCustomFilter(value) {
                this.loadSavedFilter = true;
                let newArrayDataOfOjbect = Object.values(value);
                this.masterQuery = JSON.parse(JSON.stringify(newArrayDataOfOjbect));
                this.$nextTick(function () {
                    this.loadSavedFilter = false;
                });
            },





            openNewUserModal() {
                this.$refs["addUserModal"].show();
            },
            openSaveFilterModal() {
                this.$refs["saveFilterModal"].show();
                let that = this;
                this.$nextTick(function () {
                    that.$refs["customFilterInput"].focus();
                })
            },
            openDeleteFilterModal(filterToDelete) {
                this.savedFilterToDelete = filterToDelete;
                this.$refs["deleteFilterModal"].show();
            },






            // Table operations
            goToNextPage() {
                if(this.table.currentPage < this.tablePageLength ) {
                    this.table.currentPage++;
                }
            },
            goToPrevPage() {
                if(this.table.currentPage > 1 ) {
                    this.table.currentPage--;
                }
            },
            refreshData() {
                this.getUsers();
            },
            onRowSelected(item) {
                let path = 'user/' + item[0].id;
                this.$router.push({path: path});
            },
            enterCustomPage() {
                if(this.table.currentPage > this.tablePageLength) {
                    alert('Amount Too High');
                    this.table.currentPage = 1;
                    this.table.editCurrentPage = !this.table.editCurrentPage
                } else {
                    this.table.editCurrentPage = !this.table.editCurrentPage
                }
            },

            parameters(filterName) {
                switch (filterName) {
                    case 'Created':
                        return 'on';
                    default:
                        return 'equals';
                }
            },
        },
    };
</script>

<style scoped>
    .active-filters-height {
        height: 180px;
        overflow: scroll;
    }
</style>

